const { default: axios } = require("axios");
const { default: UtilitiesUP } = require("./utilities");
const { default: Loader } = require("./Loader.js");
const { contains } = require("jquery");
const AudioRecorder = require("simple-audio-recorder");
const { message } = require("laravel-mix/src/Log");
const { forEach } = require("lodash");

const Chats = function () {

    var recorder = new AudioRecorder();

    // Raiz do chat aberto: #kt_chat_content nas telas de chat; na tela de tickets o chat chega por ajax dentro de #ticket-detail-chat.
    // oportunidades-2027 (ui-conversa DD-17): a conversa da oportunidade tem raiz própria, #op-conversa-chat — só por acréscimo, depois das duas.
    const chatRoot = () => $('#kt_chat_content').length > 0 ? $('#kt_chat_content') : ($('#ticket-detail-chat').length > 0 || $('#op-conversa-chat').length === 0 ? $('#ticket-detail-chat') : $('#op-conversa-chat'));
    let currentRoom = null;

    // D17b-2 = (a) (02-design/d17b-v02 §4 + d17b-v03 §1 + R1 do parecer-d17b-design-v03): estado real do gravador para a guarda de
    // saída da tela de tickets e "Descartar gravação" sem POST. Aditivo: nada abaixo muda. cancelar() → Promise<boolean>, nunca rejeita,
    // nunca passa de ~2 s (teto na cadeia inteira: stop() no meio do start() só responde quando a permissão responde, LICOES 53).
    const esperarParado = (ms) => new Promise((resolve) => {
        const t0 = Date.now();
        const passo = () => { if (recorder.state === 0) return resolve(true); if (Date.now() - t0 >= ms) return resolve(false); setTimeout(passo, 50); };
        passo();
    });
    window.tkGravador = {
        estado: () => recorder.state,   // 0 parado, 1 gravando, 2 pausado, 3 pedindo o microfone, 4 parando/codificando
        cancelar: () => {
            const antes = recorder.state;
            let limpo = false;
            const limpar = () => {      // idempotente: um finally tardio não apaga o botão do ticket seguinte
                if (limpo) return; limpo = true;
                $("#overlay-rec-audio-chat").fadeOut(50);
                $("#stopButton").addClass("d-none").css('pointer-events', 'all').html($("#stopButton").attr('data-val') || $("#stopButton").html());
                $("#recordButton").removeClass("d-none");
            };
            let p;
            try { p = Promise.resolve(recorder.stop()); } catch (e) { p = Promise.resolve(); }   // o Blob é ignorado: o POST só existe no stopRecording
            const cadeia = p.catch(() => {}).then(() => esperarParado(2000)).finally(limpar);
            const teto = new Promise((r) => setTimeout(() => r('teto'), 2000));
            return Promise.race([cadeia, teto]).then(() => {
                limpar();
                const e = recorder.state;
                return e === 0 || e === 4;   // R1: 4 (vindo de 1/2 ou de 3) já é seguro — o microfone apagou e não há caminho de volta a 1
            }, () => { limpar(); return recorder.state === 0 || recorder.state === 4 || antes === 3 || antes === 0; });
        },
    };

    const updateHeightList = function() {
        // console.log('atualizou')
        // var adjHeigh = $("#chat-list").height();
        // setTimeout(()=>{
        //     $("#chat-list").height(adjHeigh - 55);
        //     $("#card-custom-chat").height(adjHeigh - 32);
        //     $("#body-chat").height(adjHeigh - 300);
        // },500)

        // chats v3 - com header
        if($("#card-body-chat").find('.max-full-h').hasClass('max-full-h--with-header')){
            let heightHeaderChat = (118 + 57); // 118 header + 79 footer chat
            setTimeout(()=>{
                $("#body-chat").height($("#chat-list").height() - heightHeaderChat);
            },1000)
        }

    }

    const searchListContact = function () {
        const element = $(this);
        const url = element.closest('form').attr('action');

        KTApp.block('#kt_chat_content');

        axios.get(url)
            .then(function (response) {
                const data = response.data;
                const result = data.result;


                if (data.error === false) {
                    
                } else {
                    console.log('ops, ocorreu um erro');
                }
            });
    }

    const toggleChatMobile = function ()
    {

        if( $(window).width() <= 992 )
        {
            $("#kt_chat_aside").toggle();
            $("#kt_chat_content").toggle();            
        } 

    }

    const open = function () {
        const element = $(this);
        const url = element.data('url');

        toggleChatMobile();

        $(".act-open-chat").removeClass('contactActived');
        element.addClass('contactActived');

        element.find('.message-not-read').css('display', 'none');

        KTApp.block('#kt_chat_content');

        axios.get(url)
            .then(function (response) {
                const data = response.data;
                const result = data.result;

                if (data.error === false) {
                    $('.response-chat').html(result.html);

                    const utilitiesClass = new UtilitiesUP;
                    utilitiesClass.formSelects();

                    KTLayoutChat.setup(KTUtil.getById('kt_chat_content'));
                    KTApp.unblock('#kt_chat_content');

                    // $('.response-chat .scroll').animate({
                    //     scrollTop: chatRoot().find('.card-body .messages').height()
                    // }, 1000);
                    $('.select2').select2();

                    if($('.messages-chat-whats').hasClass('v3')){
                        console.log('chats v3');
                        if($('.chat-scroll-pagination').length > 0) {
                            $('.chat-scroll-pagination').on('scroll', scrollToPaginateInfinity)
                        }
                        $('.messages-chat-whats').animate({
                            scrollTop: ($('#kt_chat_content .resp-baloon').last().offset()!==undefined?$('#kt_chat_content .resp-baloon').last().offset().top:0)
                        }, 1000);
                    } else {
                        console.log('chats v2');
                        $('.response-chat .scroll').animate({
                            scrollTop: chatRoot().find('.card-body .messages').height()
                        }, 1000);   

                    }

                    updateHeightList();
                    start(result.chatRoom);
                }else{
                    KTApp.unblock('#kt_chat_content');
                    Swal.fire({
                        icon: "error",
                        text: data.message,
                        showCancelButton: false,
                    })
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            })
            .catch(function (error) {
                const classUtilitites = new UtilitiesUP;
                classUtilitites.showCommunicationError(error);
                console.log(error);
                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            });;
    }

    const chatList = function () {
        const room = client_name + ".chat-list";

        Echo.leave(room);
        Echo.channel(room)
            .listen('ChatList', function (response) {

                var url = $("#kt_chat_aside #chat-list").data('url') + '?chat_id=' + response.chat.id;

                filterData = {'return':'json'};

                if($('#responsibleFilter').length > 0) filterData.responsible = $('#responsibleFilter').find(":selected").val();
                filterData.value_field =  $('#searchField').val();

                var sendData = { ...response.chat, ...filterData };

                axios.post(url, sendData)
                    .then(response => {
                        const data = response.data;
                        const result = data.result;

                        if (data.error === false) {
                            var target = "";

                            if(result.target === undefined) 
                                target = '#kt_chat_aside .card-body'; 
                            else 
                                target = result.target; 
                            
                            if($(result.id).length > 0){
                                $(result.id).remove();
                            }

                            $(target).prepend(result.html);
                        }

                    })
                    .catch(function (error) {
                        // const classUtilitites = new UtilitiesUP;
                        // classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                        // console.log(error);
                    });

            });
    }

    // Já inscrito na sala: não sai e entra de novo. Com a inscrição pendente o Pusher reaproveita o canal com os listeners antigos,
    // e cada recarga do chat somava um (mensagem duplicada/triplicada). O handler é sempre o mesmo, então o stopListening só tira o nosso.
    const start = function (room) {
        if (!room || typeof Echo === 'undefined' || room === currentRoom) return;
        if (currentRoom) Echo.leave(currentRoom);   // um chat aberto por vez: sai da sala do anterior
        currentRoom = room;
        Echo.private(room)
            .stopListening('ChatMessage', onChatMessage)
            .listen('ChatMessage', onChatMessage);
    }

    // Criação, enviado e entregue da mesma mensagem chegam quase juntos: sem fila, cada evento testava #transaction_code antes de o
    // anterior inserir o balão e todos caíam em "nova" (mensagem triplicada). Eventos do mesmo transaction_code rodam em sequência.
    const filaMensagem = {};
    const onChatMessage = (response) => {
        const tc = response.transaction_code;
        if (tc === undefined || tc === null) return processChatMessage(response);

        const atual = (filaMensagem[tc] || Promise.resolve()).then(() => processChatMessage(response)).catch(() => {});
        filaMensagem[tc] = atual;
        atual.then(() => { if (filaMensagem[tc] === atual) delete filaMensagem[tc]; });
    }

    const processChatMessage = (response) => {
                var messageElement = 0;
                if(response.transaction_code != undefined && response.transaction_code != null){
                    var transaction_code = response.transaction_code;
                    messageElement = $("#"+transaction_code).length;
                }
                
                if((typeof transaction_code === 'undefined') || messageElement == 0){
                    const url = chatRoot().find('.messages').data('format');
                    // Painel do chat fora da tela (troca de ticket em andamento, ticket sem chat): sem URL não há o que atualizar.
                    // Antes ia axios.post(undefined) → POST /…/undefined → 404 → alerta "Erro de comunicação". O chat recarrega ao abrir.
                    if (!url) return Promise.resolve();

                    filterData = {'return':'json'};
                    
                    if($('#responsibleFilter').length > 0) filterData.responsible = $('#responsibleFilter').find(":selected").val();

                    var sendData = { ...response.chatMessage, ...filterData };


                    return axios.post(url, sendData)
                        .then(function (response) {
                            const data = response.data;
                            const result = data.result;   
                            
                            if (data.error == false) {
                                let sectionMessages = chatRoot().find('.messages');
    
                                if (result.user_id == sectionMessages.data('user_id') && result.chat_channel_id == sectionMessages.data('chat_channel_id')) {
                                    const jaExiste = result.transaction_code ? sectionMessages.find('#' + result.transaction_code) : $();
                                    if (jaExiste.length > 0) jaExiste.replaceWith(result.html); else sectionMessages.append(result.html);

                                    if(result.html_footer != undefined && $('#content').length == 0){
                                        chatRoot().find('.card-footer').replaceWith(result.html_footer);
                                    }
    
                                    $('.scroll').animate({
                                        scrollTop: chatRoot().find('.card-body .messages').height()
                                    }, 100);
    
                                    let context = new AudioContext();
                                    if (context.state == "running") {
                                        document.getElementById('audio-notification').play()
                                    }
                                }
                            }
                        })
                        .catch(function (error) {
                            const classUtilitites = new UtilitiesUP;
                            classUtilitites.showCommunicationError(error);
                            console.log(error);
                        });
                }else{
                    const url = chatRoot().find('.messages').data('update-message');
                    if (!url) return Promise.resolve();   // idem: painel do chat fora da tela

                    return axios.post(url, response.chatMessage)
                        .then(function (response) {
                            const data = response.data;
                            const result = data.result;

                            $(result.target).replaceWith(result.html);
    
                            $('.scroll').animate({
                                scrollTop: chatRoot().find('.card-body .messages').height()
                            }, 100);

                            if(result.error_json != undefined && result.error_json != ''){
                                if(result.error_json.action != undefined){
                                    if (result.error_json.action ==="sendFlow") {
                                        const classUtilitites = new UtilitiesUP;
                                        classUtilitites.showAlert(result.error_json.translated_error, "Ok");
                                        location.reload();
                                    }
                                }
                            }
                            
                        })
                        .catch(function (error) {
                            // const classUtilitites = new UtilitiesUP;
                            // classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                            // console.log(error);
                        });
                }

    }

    const sendMessage = function (event) {
        event.preventDefault()

        const element = $(this);

        if(event.target.classList.contains('waiting-send')) return;

        event.target.classList.add('waiting-send');
        
        // element.find('button.chat-send').attr('disabled', 'disabled');
        element.find('button.chat-send').prop('disabled', true);



        $(".fDerror").hide();
        var errorFD = 0;

        $(".validate-flow_paramns").each(function(){
            if( $(this).val() == "") {
                errorFD = 1;
            }            
        });
        
        if(errorFD > 0) {
            $(this).parent().find('.fDerror').show();
            return false;
        }

        const url = element.attr('action');
        const data = element.serialize();

        if (data.indexOf("flow_id") > 0) {
            KTApp.block('.chat-close');
        }

        axios.post(url, data)
            .then(function (response) {
                const data = response.data;
                const result = data.result;

                if (data.error) {

                    let changeFooter = ["needs_message_template", "chat_close"];

                    if (changeFooter.includes(result.error_slug)) {
                        /* $('#kt_chat_content .card-footer').remove();
                        $('#kt_chat_content .card-body').after(result.html); */
                        $("#chat-card-footer").remove();
                        $('#card-body-chat').after(result.html);
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: data.message
                    });

                    if(element.find('#content').val() != '') element.find('button.chat-send').prop('disabled', false);//element.find('button.chat-send').removeAttr('disabled');

                } else {
                    element.find('#content').val("");
                    //textarea volta tamanho normal
                    $('.textarea-autoHeight').height('auto');

                    $('.chat-close, .chat-open').addClass('d-none');

                    if (result.success_slug == "flow_processed") {
                        $('.chat-open').removeClass('d-none');
                        /* $('#kt_chat_content .card-footer').remove();
                        $('#kt_chat_content .card-body').after(result.html); */
                        $("#chat-card-footer").remove();
                        $('#card-body-chat').after(result.html);

                        if(result.html_message !== undefined && result.html_message != '') chatRoot().find('.messages').append(result.html_message);

                        const utilitiesClass = new UtilitiesUP;
                        utilitiesClass.formSelects();

                        KTApp.unblock('.chat-close');

                    }

                    if (result.success_slug == "message_send") {
                        $('.chat-open').removeClass('d-none');
                        $("#whatsapi-send-button").hide();
                        $("#recordButton").show();
                        // $("#kt_chat_content .messages").append(result.html);
                        if(result.html !== undefined && result.html != '') chatRoot().find('.messages').append(result.html);

                        $('.scroll').animate({
                            scrollTop: chatRoot().find('.messages').height()
                            // scrollTop: chatRoot().find('.card-body .messages').height()
                        }, 100);
                    }

                    if(element.find('#content').val() != '') element.find('button.chat-send').prop('disabled', false);//element.find('button.chat-send').removeAttr('disabled');
                }
                event.target.classList.remove('waiting-send');
            })
            .catch(function (error) {
                const classUtilitites = new UtilitiesUP;
                classUtilitites.showCommunicationError(error);
                console.log(error);
            });
    }

    const sendFile = function (event) {

        var fileInput = document.getElementById('uploadFileChat');
        var blob = fileInput.files[0];
        var formData = new FormData();
        formData.append('userfile', blob);
        formData.append('content', '.');
        formData.append('sendFile', true);
        formData.append('chat_id', $("#uploadFileChat").data('chat_id'));

        if($("#user_id").length > 0)formData.append('user_id', $("#user_id").val());
        if($("#name_to").length > 0)formData.append('name_to', $("#name_to").val());
        if($("#ddi_to").length > 0)formData.append('ddi_to', $("#ddi_to").val());
        if($("#phone_to").length > 0)formData.append('phone_to', $("#phone_to").val());
        if($("#channel_id").length > 0)formData.append('channel_id', $("#channel_id").val());
        if($("#chat_type_id").length > 0)formData.append('chat_type_id', $("#chat_type_id").val());
        if($("#chat_type").length > 0)formData.append('chat_type', $("#chat_type").val());


        axios.post($('#uploadFileChat').data('url'), formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        }).then(function (response) {

            let data = response.data;


            if (data.error === false) {

                let result = data.result;
                chatRoot().find('.messages').append(result.html);

            } else {
                Swal.fire({
                    icon: "error",
                    text: data.message,
                    showCancelButton: false,
                })
                if (data.result.method != undefined) {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }

            $("#stopButton").addClass("d-none");
            $("#recordButton").removeClass("d-none");
            $("#stopButton").html($("#stopButton").attr('data-val'));

            $('.scroll').animate({
                scrollTop: chatRoot().find('.card-body .messages').height()
            }, 100);
        });

    }

    // const startRecording = function (event) {
    //     $("#recordButton").addClass("d-none");
    //     $("#stopButton").removeClass("d-none");
    //     $("#stopButton").css('pointer-events', 'all');

    //     navigator.mediaDevices.getUserMedia({ audio: true })
    //         .then(function (stream) {
    //             recorder = new MediaRecorder(stream);

    //             // when there is data, compile into object for preview src
    //             recorder.ondataavailable = function (e) {
    //                 let blob = new Blob([e.data], { type: "audio/mpeg-3" });
    //                 let formData = new FormData();
    //                 formData.append('audio', blob, 'audio.mp3');
    //                 formData.append('content', '.');
    //                 formData.append('audio', true);
    //                 formData.append('chat_id', $("#stopButton").data('chat_id'));

    //                 axios.post($('#stopButton').data('url'), formData, {
    //                     headers: {
    //                         "Content-Type": "multipart/form-data"
    //                     },
    //                 })
    //                     .then(function (response) {

    //                         let data = response.data;


    //                         if (data.error === false) {

    //                             let result = data.result;
    //                             chatRoot().find('.messages').append(result.html);

    //                         } else {
    //                             Swal.fire({
    //                                 icon: "error",
    //                                 text: data.message,
    //                                 showCancelButton: false,
    //                             })
    //                             if (data.result.method != undefined) {
    //                                 setTimeout(function () {
    //                                     location.reload();
    //                                 }, 1000);
    //                             }
    //                         }

    //                         $("#stopButton").addClass("d-none");
    //                         $("#recordButton").removeClass("d-none");
    //                         $("#stopButton").html($("#stopButton").attr('data-val'));

    //                         $('.scroll').animate({
    //                             scrollTop: chatRoot().find('.card-body .messages').height()
    //                         }, 100);


    //                     });
    //             };
    //             recorder.start();

    //             timeout_status = setTimeout(function () {
    //                 console.log("5 min timeout");
    //                 stopRecording();
    //             }, 300000);
    //         });
    // }

    // const stopRecording = function (event) {

    //     let val = $("#stopButton").html();

    //     $("#stopButton").attr('data-val', val);
    //     $("#stopButton").html($("#stopButton").attr('data-wait'));
    //     $("#stopButton").css('pointer-events', 'none');

    //     recorder.stop();

    // }

    const startRecording = function (event) {

        $("#overlay-rec-audio-chat").fadeIn(50);

        $("#recordButton").addClass("d-none");
        $("#stopButton").removeClass("d-none");
        $("#stopButton").css('pointer-events', 'all');

        AudioRecorder.preload("https://cdn.jsdelivr.net/npm/simple-audio-recorder@0.0.3/dist/mp3worker.js");

        recorder.start().then(() => {
            console.log("Recording started...");
        }).catch(error => {
            console.log(error);
            $("#overlay-rec-audio-chat").fadeOut(50);
        });
    }

    const stopRecording = function (event) {

        $("#overlay-rec-audio-chat").fadeOut(50);

        let val = $("#stopButton").html();

        $("#stopButton").attr('data-val', val);
        $("#stopButton").html($("#stopButton").attr('data-wait'));
        $("#stopButton").css('pointer-events', 'none');

        recorder.stop().then(mp3Blob => {
            console.log("Recording stopped...");

            let formData = new FormData();
            formData.append('audio', mp3Blob, 'audio.mp3');
            formData.append('content', '.');
            formData.append('audio', true);
            formData.append('chat_id', $("#stopButton").data('chat_id'));

            if($("#user_id").length > 0)formData.append('user_id', $("#user_id").val());
            if($("#name_to").length > 0)formData.append('name_to', $("#name_to").val());
            if($("#phone_to").length > 0)formData.append('phone_to', $("#phone_to").val());
            if($("#channel_id").length > 0)formData.append('channel_id', $("#channel_id").val());
            if($("#chat_type_id").length > 0)formData.append('chat_type_id', $("#chat_type_id").val());
            if($("#chat_type").length > 0)formData.append('chat_type', $("#chat_type").val());
            if($("#ddi_to").length > 0)formData.append('ddi_to', $("#ddi_to").val());

            axios.post($('#stopButton').data('url'), formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            })
                .then(function (response) {

                    let data = response.data;


                    if (data.error === false) {

                        let result = data.result;

                        // console.log($(document).find('#'.result.message_id));
                        // console.log($(document).find('#'.result.message_id).length);

                        // chatRoot().find('.messages').append(result.html);

                        if(result.transaction_code !== undefined){
                            console.log($(document).find('#'.result.transaction_code));
                            console.log($(document).find('#'.result.transaction_code).length);
                            if($(document).find('#'.result.transaction_code).length > 0){
                                $(document).find('#'.result.transaction_code).replaceWith(result.html);
                            }
                        }else{
                            chatRoot().find('.messages').append(result.html);
                        }

                    } else {
                        Swal.fire({
                            icon: "error",
                            text: data.message,
                            showCancelButton: false,
                        })
                        if (data.result.method != undefined) {
                            setTimeout(function () {
                                location.reload();
                            }, 1000);
                        }
                    }

                    $("#stopButton").addClass("d-none");
                    $("#recordButton").removeClass("d-none");
                    $("#stopButton").html($("#stopButton").attr('data-val'));

                    $('.scroll').animate({
                        scrollTop: chatRoot().find('.card-body .messages').height()
                    }, 100);


                });

        }).catch(error => {
            console.log(error);
        });
    }

    const selectFlow = function () {

        var demoTextarea = $("#box-textarea-realtime");

        console.log('one...');
        const element = $(this);

        if(element.val() != "") {
            $("#container-flow").show();
        } else {
            $("#container-flow").hide();
        }

        const value = element.val();
        const url = element.data('url');
        KTApp.block('#container-flow');

        axios.post(url, {
            flow: value
        })
        .then(function (response) {
            const data = response.data;
            const result = data.result;

            let newValue = "";
            if (data.error === false) {
                newValue = result.content;

                let params = JSON.parse(result.params);
                let flowParams = "";
                $('#container-flow-params').html("");

                // param = 1 => up_cliente, 2 => up_corretor
                if(params !== null ) 
                {
                    
                    Object.keys(params).forEach(key => {
                        if (params[key] !== 'huggy.chat.contact.name') {
                            flowParams += '<label for="flow-param-' + key + '" class="form-label font-size-sm mt-3">Parâmetro ' + key + ' *</label><div class="mb-3 d-flex rounded bg-gray-200 position-relative"><textarea name="flow_param[' + params[key] + ']" id="flow-param-' + key + '" class="textarea-js-param-realtime form-control rounded bg-gray-200 border-0 validate-flow_paramns count-caracteres textarea-autoHeight template-item-'+ params[key] +'" maxlength="500" rows="1" data-key="'+ key +'"></textarea> <div class="limite-textarea-abs"><span class="limite-textarea font-size-xs text-muted"></span> </div></div><span style="display:none;" class="text-danger fDerror font-size-xs mt-2">*Campo obrigatório.</span>';
                        }

                        setTimeout(() => {
                            let strLoad = demoTextarea.html();
                            strReplaceDinamic(key,strLoad,$(`#flow-param-${key}`).val());
                        }, 500);
                        
                    });

                    $(document).on('keyup', '.textarea-js-param-realtime', function(){

                        let el = $(this);
                        let strText = demoTextarea.html();
                        let newStr = el.val();
                        let key = el.attr('data-key');

                        strReplaceDinamic(key,strText,newStr);

                    });

                    /* Substituo os parametros {{1}} 2 {{2}} por classes para serem dinamicas ao digitar */
                    function strReplaceDinamic(nKey, nStr,vHtml){
                        demoTextarea.html(nStr.replace('{{'+nKey+'}}', "<span class='text-success param-"+nKey+"'></span>")); 
                        $('.param-'+nKey).html(vHtml);
                        if($('.param-'+nKey).is(':empty')) {
                            $('.param-'+nKey).html('___');
                        }
                    }

                    // wrap dos textareas dinamicos cliente e corretor
                    $('#container-flow-params').html(flowParams);

                    // textarea do corretor
                    if ($('.template-item-up_corretor').length > 0) {
                        $('.template-item-up_corretor').val(result.user_responsable);
                    }

                    // textarea do cliente
                    if ($('.template-item-up_client').length > 0) {
                        $('.template-item-up_client').val(result.client);
                    }

                    // autoHeightTextarea(element.find('.textarea-autoHeight'));
                    $('textarea').each(function(i,e){
                        setTimeout(() => {
                            $(this).height('auto');
                            $(this).height($(this).get(0).scrollHeight) 
                        }, 500);
                    });
                } 

                // textarea main
                $("#flow_content").val(newValue);

                //demoTextarea.html($("#flow_content").val().replaceAll(" ", "&nbsp;").replace(/\r\n|\r|\n/g, "<br />"));

                
                // cópia exata do textarea, essa demo é a visual ao entrar no chat template
                const copyText = $("#flow_content").val().replaceAll(" ", "&nbsp;").replace(/\r\n|\r|\n/g, "<br />");

                // trato &nbsp; para "" assim obedecendo quebras de linha no responsivo.
                demoTextarea.html(copyText.replace(/&nbsp;/g, " "));
                

            }

            
            KTApp.unblock('#container-flow');
        })
        .catch(function (error) {
            const classUtilitites = new UtilitiesUP;
            classUtilitites.showCommunicationError(error);
            console.log(error);
        });
    }

    const responsibleFilter = function() {
        var element = $(this);
    
        var elementData = $(this).data();
        if(elementData.select2 !== undefined) delete elementData.select2;
    
        // console.log(elementData)
    
        Loader.show();
        // $('html').css('overflow', 'hidden');
    
        if(elementData.field !== undefined){
            elementData[elementData.field] = element.val();
        }
    
        var sendData = {
            'value': element.val(),
            'data': elementData,
            'value_field': $('#searchField').val()
        }

        $('#searchField').attr('data-responsible', element.val());
        $('#allChats').attr('data-responsible', element.val());
        $('#unreadChats').attr('data-responsible', element.val());
    
        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: element.data('urlajax'), 
            data: sendData,
            dataType: "json",
            success: function (data) {
    
                // $('html').css('overflow', 'auto');
                Loader.hide();
    
                if (!data.error) {
                    const classUtilitites = new UtilitiesUP;
                    classUtilitites.switchReturns(data, element);
                }
    
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // $('html').css('overflow', 'auto');
                Loader.hide();
                const classUtilitites = new UtilitiesUP;
                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        });
    }

    const filterForNameChat = function () {

        const utilitiesClass = new UtilitiesUP;
        let timer;
        
        $('.filter-for-name-chat-keyup').each(function(){
            
            const element = $(this);

            element.on('keyup', function() {
                
                clearTimeout(timer);
                
                timer = setTimeout(function () {
                    
                    const url_ajax = element.attr("data-ajax");   
                    const searchSesponsible =  element.attr("data-responsible");
   
                    Loader.show();    
                    element.attr('disabled', 'disabled');
                    
                    let sendData = {
                        value_field : element.val(),
                        responsible : searchSesponsible
                    };
            
                    $.ajax({
                        type: "POST",
                        headers: {
                            'X-CSRF-TOKEN': CSRF_TOKEN
                        },
                        url: url_ajax,
                        data: sendData,
                        dataType: "json",
                        success: function (data) {
                            // $('html').css('overflow', 'auto');
                            console.log(data);
                            Loader.hide();
                            element.removeAttr('disabled');

                            utilitiesClass.switchReturns(data, element);
                            utilitiesClass.formSelects();
            
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            // $('html').css('overflow', 'auto');
                            Loader.hide();
                            element.removeAttr('disabled');
            
                            console.log("Erro de comunicação, por favor, recarregue a página", "Ok");
            
                        }
                    });
        
                }, 1500);            

            })


        })
        

        
        
        
    }

    const limiteCharText = function(elm)
    {
        var _this = elm;
        var limitChar = parseInt(_this.attr('maxlength'));

        if(_this.val().length > limitChar ) return;
        _this.parent().find('.limite-textarea').text("Restam: " + (limitChar - _this.val().length) + " de " +limitChar+" caractéres");
    }

    const autoHeightTextarea = (element) => {
        if($(window).width() <= 768) return;
        
        // const scrollingElement = (document.scrollingElement || document.body);
        element.style.height = "5px";
        element.style.height = (element.scrollHeight) + "px";
        // scrollingElement.scrollTop = scrollingElement.scrollHeight;
    }

    const toggleSends = (el) => {
        if(el.val().length > 0) {
            $("#whatsapi-send-button").show();
            $("#recordButton").hide();
        } else {
            $("#whatsapi-send-button").hide();
            $("#recordButton").show();
        }
    }

    return {
        init: function () {
            
            if($(document).find('.act-open-chat').length > 0){
                chatList();
                updateHeightList();
                if($(window).width() > 992) {
                    $(window).on('resize', function () {
                        updateHeightList();
                    });
                }
            }

            if( $(document).find('.filter-for-name-chat-keyup').length > 0) {
                filterForNameChat();
            }
    
                $(document).on('click', '.act-open-chat', open);
                // Chat carregado por ajax fora da tela de chat (ex.: .execute-ajax-on-load do ticket): o switchReturns avisa a sala.
                $(document).on('chat:room', (e, room) => start(room));
                $(document).on('submit', "form#send-message", sendMessage);
    
                $(document).on('click', '#recordButton', startRecording);
                $(document).on('click', '#stopButton', stopRecording);
                
                $(document).on('change', '#uploadFileChat', sendFile);
                $(document).on('change', '#flow_id', selectFlow)

                $(document).on("change", "#responsibleFilter", responsibleFilter);
    
                $(document).on('keydown', '#content', function (e) {
                    if (e.which === 13 && !e.shiftKey) {
                        e.preventDefault();
                        if($('.chat-send[disabled=disabled]').length == 0) $("form#send-message").trigger('submit');
                        return false;
                    }
                });
                $(document).on('keyup', '#content', function (e) {
                    if($(document).find('#content').val() != '') $(document).find('button.chat-send').removeAttr('disabled');
                    if($(document).find('#content').val() == '') $(document).find('button.chat-send').attr('disabled','disabled');
                });
                
                $(document).on('click', '#backToContacts', toggleChatMobile);
                
                $(document).on('keyup', '.count-caracteres', function () {
                    limiteCharText($(this));
                })
                $(document).on('keyup', '.textarea-autoHeight', function () {
                    autoHeightTextarea(this);
                })

                $(document).on('keyup', '.textarea-toggle-sends', function(){
                    toggleSends($(this));
                });
            
        }
    }
}();

// export default Chats
module.exports = Chats